export default __webpack_public_path__ + "static/media/BondingImg.7efc7008.jpg";